import React, { useEffect, useState, useContext } from 'react';
import {
    Box,
    Typography,
    Paper,
    Link,
    Button,
    Avatar
} from '@mui/material';
import VenueList from '../VenueList.tsx';
import {Crumbs} from "../Crumbs.jsx";
import {OutOfTownURI} from "../Button/OutOfTownButton.jsx";
import {DanceEventContext} from "../DanceEventProvider.jsx";
import {Helmet} from "react-helmet";
import {InTownURI} from "../Button/InTownButton.jsx";

const title = "All 2-Step spots In and Around Austin";
const desc = "Includes what to expect, most popular days, directions, cover charges and age restrictions";
const BACKEND_HOST = process.env["REACT_APP_BACKEND_HOST"];

const InTownPage = () => {
    const [venues, setVenues] = useState([]);
    const deContext = useContext(DanceEventContext);

    useEffect(() => {
        let allVenues = [];
        let page = 1;
        let totalPages = 1;

        const fetchVenues = async () => {
            do {
                const res = await fetch(`${BACKEND_HOST}/venues?filters[market][$eq]=local&pagination[page]=${page}&pagination[pageSize]=100&populate[]=images&sort[name]=asc`);
                const data = await res.json();
                allVenues = allVenues.concat(data.data || []);
                totalPages = data.meta?.pagination?.pageCount || 1;
                page++;
            } while (page <= totalPages);

            setVenues(allVenues);
        };

        fetchVenues();
    }, []);

    // Calculate event counts for each venue if events are available
    const venueEventCounts = deContext.events.reduce((acc, event) => {
        const {date, venue} = event;
        const {venueKey} = venue;
        if (!acc.hasOwnProperty(venueKey)) {
            acc[venueKey] = {};
        }
        acc[venueKey][date] = true
        return acc;
    }, {});

    // Add eventCount to each venue object
    const venuesWithEventCount = venues.map(v => {
        const venueKey = v.attributes?.venueKey || v.venueKey;
        if (venueEventCounts.hasOwnProperty(venueKey)) {
            v.eventCount = Object.keys(venueEventCounts[venueKey]).length;
        } else {
            v.eventCount = 0;
        }
        return v;
    });

    return (
        <Box>
            <Helmet>
                <meta charSet="utf-8"/>
                <meta property="og:description" content={desc}/>
                <meta property="og:title" content={title}/>
                <meta property="twitter:title" content={title}/>
                <meta property="twitter:description" content={desc}/>
                <title>{title}</title>
                <meta property="description" content={desc} />
                <link rel="canonical" href={InTownURI}/>
            </Helmet>
            <Crumbs crumbs={[
                {title: "Where To Dance", href: "/where-to-dance"},
                {title: "In & Near Town"}
            ]} />

            {/* Page header */}
            <Typography variant="h6" component="h1" gutterBottom sx={{ mt: 4 }}>
                Venues Inside & Near Austin
            </Typography>

            <Box p={2} bgcolor={"background.paper"} borderRadius={1} style={{display: 'flex', alignItems: 'center', marginBottom: 16}}>
                <Avatar style={{ float:"left", marginRight: 8 }} alt="Community Member" src="/images/ellie.jpeg" />
                <Typography variant="caption" color="textSecondary" gutterBottom>
                    This community page is curated by Ellie.
                </Typography>
            </Box>

            <Paper>
                <Box m={2} py={2}>
                    All of the places we dance around Austin. Venues marked with "XX upcoming events" are included on the calendar.
                </Box>
                <Box m={2}>
                    Found a great venue? Share it here!
                </Box>
                <Box m={2} pb={2}>
                    <Button href={"/venue/edit/new"} variant={"contained"} size={"small"}>Add Venue</Button>
                </Box>
                <Box m={2} pb={2}>
                    Also see all of the venues <Link href={OutOfTownURI} variant={"contained"} size={"small"}>out of town</Link>.
                </Box>
            </Paper>
            {/* Venue list component */}
            <Box>
                <VenueList venues={venuesWithEventCount} showCityState={false} />
            </Box>
        </Box>
    );
};

export default InTownPage;